/**
 * MSAL Authentication Configuration
 * For LensLock Client Map standalone app
 */
import { Configuration, LogLevel } from "@azure/msal-browser";

// Get configuration from environment variables
const clientId = process.env.REACT_APP_CLIENT_ID || "";
const tenantId = process.env.REACT_APP_TENANT_ID || "";

if (!clientId || !tenantId) {
  console.warn("Missing REACT_APP_CLIENT_ID or REACT_APP_TENANT_ID environment variables");
}

/**
 * MSAL Configuration
 */
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Login request scopes
 */
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
